// extracted by mini-css-extract-plugin
export var adjacentSlide = "_pc-9";
export var arrowButtonContainer = "_pc-5";
export var arrowButtonIcon = "_pc-6";
export var carouselArrowButton = "_pc-2";
export var carouselElementContainer = "_pc-1";
export var currentSlide = "_pc-8";
export var left = "_pc-3";
export var otherSlide = "_pc-a";
export var productCarouselContainer = "_pc-0";
export var right = "_pc-4";
export var sliderOverflow = "_pc-7";